var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSolidRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jklvh2sx6a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.224 4.012C5.11 6.385 3.658 9.795 3.523 10.116L1.18 9.11a1.04 1.04 0 0 1-.322-1.69L3.98 4.302a2.088 2.088 0 0 1 1.877-.57l1.368.28zM8.77 14.54c.311.31.768.394 1.162.207 1.203-.56 3.784-1.875 5.454-3.544 4.759-4.757 4.8-8.633 4.52-10.29a1.014 1.014 0 0 0-.819-.82C17.427-.185 13.55-.143 8.79 4.614c-1.67 1.668-2.976 4.249-3.546 5.451-.187.394-.093.86.207 1.16l3.318 3.317zm7.227-1.762c-2.374 2.114-5.785 3.565-6.107 3.7l1.006 2.342a1.04 1.04 0 0 0 1.69.321l3.121-3.119a2.086 2.086 0 0 0 .57-1.876l-.28-1.368zm-9.03 2.695a3.107 3.107 0 0 1-.851 2.808c-.798.798-3.276 1.389-4.884 1.7a1.041 1.041 0 0 1-1.213-1.213c.311-1.606.892-4.083 1.7-4.88a3.11 3.11 0 0 1 2.81-.85 3.102 3.102 0 0 1 2.437 2.435zm4.209-8.716a2.08 2.08 0 0 1 2.074-2.072 2.08 2.08 0 0 1 2.073 2.072 2.08 2.08 0 0 1-2.073 2.073 2.08 2.08 0 0 1-2.074-2.073z",
    fill: "#465DD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jklvh2sx6a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidRocket);
export default __webpack_public_path__ + "static/media/icon-solid-rocket.8f358eff.svg";
export { ForwardRef as ReactComponent };